/*
    Titolo dei popup su una sola riga.
    Il testo non va mai a capo (white-space: nowrap nel CSS): se la targa non ci sta nello spazio
    disponibile, viene ridotta quanto basta. Una targa che ci sta già resta alla dimensione del foglio di stile.
    La riduzione è un fattore di scala (--fit sulla targa, 1 = normale): il CSS lo applica a testo, icona e
    margini laterali, qualunque sia la variabile che ne fissa la dimensione (--pop-title, --pop-banner).
*/

//sotto questa scala non si scende: il titolo viene troncato con "…"
export const MIN_TITLE_SCALE = 0.55;

//margine di tolleranza (px) per gli arrotondamenti di offsetWidth / clientWidth
const TOLERANCE = 1;

export function fitPlateTitle(plateEl, textEl) {
    //riparte dalla dimensione del foglio di stile, che cambia con la larghezza dello schermo
    plateEl.style.removeProperty("--fit");
    plateEl.classList.remove("pop-plate-clip");

    //larghezza che la targa vorrebbe (testo + riempimento): la targa è limitata da max-width,
    //quindi clientWidth è più piccolo di questa solo se non ci sta
    const wanted = () => {
        const cs = getComputedStyle(plateEl);
        return textEl.offsetWidth + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    };
    const overflows = () => wanted() > plateEl.clientWidth + TOLERANCE;

    let scale = 1;

    //una parte del riempimento (lo spazio dell'icona) non scala: il rapporto non basta al primo colpo, qualche passo converge
    for (let i = 0; i < 6 && overflows(); i++) {
        scale = Math.max(MIN_TITLE_SCALE, scale * plateEl.clientWidth / wanted());
        plateEl.style.setProperty("--fit", scale);
    }

    //caso estremo (titolo lunghissimo su schermo minuscolo): taglia con i puntini invece di uscire dalla targa
    if (overflows()) {
        plateEl.classList.add("pop-plate-clip");
    }
}
